'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterElement = undefined;

var _elementHelper = require('../../../common/elements/elementHelper');

var filterElement = exports.filterElement = function filterElement(element, elementFilter) {
    var modified = element.getIn(['meta', 'significantModified']);
    var modifiedBy = element.getIn(['meta', 'modifiedBy']);
    var elementId = (0, _elementHelper.getPhysicalId)(element);

    if (elementFilter.modifiedAfter && (!modified || modified < elementFilter.modifiedAfter)) return false;
    if (elementFilter.modifiedBefore && (!modified || modified > elementFilter.modifiedBefore)) return false;
    if (elementFilter.modifiedBy && elementFilter.modifiedBy.indexOf(modifiedBy) === -1) return false;
    if (elementFilter.ids && elementFilter.ids.indexOf(elementId) === -1) return false;

    return true;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementFilter/elementFilterUtil.js
// module id = 728
// module chunks = 0